import React from "react";
import styled from "styled-components";
import { primaryColor } from "../../../constants/colors";
import { isTabOrDesktop } from "../../../store/UiUtils";

const BookingDateSelector = ({ dates, selectedDate, onDateClick }) => {
  return (
    <Wrapper className="container">
      <div className={`d-flex align-items-center gap-2 dateWrapper ${!isTabOrDesktop ? "hide-scrollbar" : ""}`} style={{ overflowX: "scroll" }}>
        {dates.map((date, i) => {
          const dayName = date.toLocaleString("en-US", { weekday: "short" }).toUpperCase();
          const dayNumber = date.getDate();
          return (
            <button key={i} onClick={() => onDateClick(date)} className="py-2 px-3 dateTime" style={{ backgroundColor: selectedDate === date ? primaryColor : null }}>
              <div className="col">
                <strong style={{ color: selectedDate === date ? "white" : null }}>{dayName}</strong>
                <strong style={{ color: selectedDate === date ? "white" : null }}>{dayNumber}</strong>
              </div>
            </button>
          );
        })}
      </div>
    </Wrapper>
  );
};

export default BookingDateSelector;

const Wrapper = styled.div`
  .dateWrapper {
    padding-bottom: 18px;
  }
  .dateWrapper::-webkit-scrollbar-thumb {
    background: ${primaryColor};
    border-radius: 10px;
  }
  button {
    outline: none;
    border: none;
  }
  .dateWrapper .dateTime {
    background-color: #e4e4e4;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .dateTime strong:nth-child(1) {
    display: block;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 400;
  }
  .dateTime strong {
    display: block;
    text-align: center;
    color: #000;
    font-size: 1.2rem;
  }
  p {
    margin-bottom: 0.4rem;
  }
`;
